import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import styles from './Rectangle.css';


const actions = {};

/** CopyMe component description */
class Rectangle extends Component {
    constructor(props) {
        super(props);

        // console.log('props', props);

        this.color = props.color || "0xFFFFFF";
        this.width = props.width || 300;
        this.height = props.height || 200;
        this.x = props.x || 0;
        this.y = props.y || 0;
    }

    
    render() {
        const style = this.props.imgStyle ? this.props.imgStyle : {
            width: this.props.width,
            height: this.props.height
        }

        return (<div
            className="Rectangle"
            style={{
                id: this.props.id,
                width: this.props.width,
                height: this.props.height,
                left: this.props.x,
                top: this.props.y,
                background: this.props.background,
                border: '2px solid ' + this.props.fg_color,
                pointerEvents: 'none',
                overflow: 'hidden'
                
            }}
        >


            {
                this.props.src ? <img 
                    src={`${process.env.PUBLIC_URL}/${this.props.src}`} 
                    style={style}
                />
                : null}
            {this.props.children}
        </div>);
    }
}

const mapStateToProps = (state, ownProps) => {
    const z = state.camera.zoom;
    return Object.assign(
        {}, 
        {
        },
        {
            x: parseInt((ownProps.x + state.camera.pan.x) * z + state.camera.size.width/2),
            y: parseInt((ownProps.y + state.camera.pan.y) * z + state.camera.size.height/2),

            width: parseInt((ownProps.width) * z),
            height: parseInt((ownProps.height) * z),

            // zoom: z,
        }
    );
}

Rectangle.displayName = "RectangleComponent";
const connectedComponent = connect(
    mapStateToProps,
    {
        ...actions
    }
)(Rectangle);
connectedComponent.displayName = "Rectangle";


Rectangle.propTypes = {

};

export default connectedComponent;
export { Rectangle as RectangleComponent };